<div class="{{ class }}" [ngClass]="innerClass">
  @if(parentForm){
  <mat-label *ngIf="label" class="pb-1"
    >{{ label }} <span *ngIf="required" class="required">*</span></mat-label
  >
  <div class="form-group" [formGroup]="parentForm">
    <!-- tag with input autocomplete -->
    <div *ngIf="inputAutoCompletetWithTag">
      <mat-form-field class="example-chip-list">
        <mat-chip-grid #chipGrid aria-label="Fruit selection">
          @for (item of optionsDisplay; track item) {
          <mat-chip-row (removed)="remove(item)">
            {{ item?.label }}
            <button matChipRemove [attr.aria-label]="'remove ' + item?.value">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
          }
        </mat-chip-grid>
        <input
          [placeholder]="inputPlaceHolder"
          [formControl]="inputControl"
          [matChipInputFor]="chipGrid"
          [matAutocomplete]="auto"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="selected($event)"
        >
          @for (item of filteredList | async; track item) {
          <mat-option [value]="item?.value || item?.id">{{
            item?.label || item?.name
          }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div *ngIf="simpleDropDown" class="{{ simpleDropDownClass }}">
      <mat-form-field class="dropdownClass" appearance="outline">
        <mat-label *ngIf="placeholder">{{ placeholder }}</mat-label>
        <mat-select [multiple]="multiple" [formControlName]="controlName" panelClass="app-searchable-dropdown-panel">
          <app-custom-input
            *ngIf="withSearch"
            class="app-dropdown-search"
            [placeholder]="'Mot clé...'"
            [control]="keyword"
            (keydown)="$event.stopPropagation()"
            inputClass="border border-neutral-light-grey border-r-4"
            innerClass="p-px-10 "
          ></app-custom-input>
          <mat-option value="" *ngIf="loading">Loading...</mat-option>
          @for (item of optionsDisplay; track item) {
          <mat-option
            [value]="
              item?.value
                ? item?.value
                : item?.value == false
                ? item?.value
                : item?.id
            "
          >
            <svg-icon *ngIf="item.icon" [src]="item.icon"></svg-icon>
            {{ item?.label || item?.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div
        class="invalid-feedback"
        *ngIf="
          parentForm.get(controlName)?.invalid &&
          parentForm.get(controlName)?.touched
        "
      >
        {{ "Le champ " + label + " est " + errorMessage }}
      </div>
      <div class="text-secondary helper" *ngIf="helper">
        {{ helper }}
      </div>
    </div>
  </div>
  } @else {
  <ng-container>
    <div>
      <mat-label *ngIf="label" class="pb-1"
        >{{ label }} <span *ngIf="required" class="required">*</span></mat-label
      >
      <mat-form-field class="dropdownClass" appearance="outline">
        <mat-label *ngIf="placeholder">
          <svg-icon
            *ngIf="sideIcon && positionIcon == 'left'"
            src="{{ sideIcon }}"
          ></svg-icon>
          {{ placeholder
          }}<svg-icon
            *ngIf="sideIcon && positionIcon == 'right'"
            src="{{ sideIcon }}"
          ></svg-icon
        ></mat-label>
        <mat-select [multiple]="multiple">
          @for (item of optionsDisplay; track item) {
          <mat-option [value]="item?.value || item?.id">
            <svg-icon *ngIf="item.icon" [src]="item.icon"></svg-icon>
            {{ item?.label || item?.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="text-secondary helper" *ngIf="helper">
        {{ helper }}
      </div>
    </div>
  </ng-container>
  }
</div>
